import { Link } from "react-router-dom";
import { useDemoRequest } from "@/components/feature/DemoRequest";

const plans = [
  {
    name: "Starter",
    desc: "For small teams getting started with operational structure.",
    features: ["2 Products", "Up to 50 Users", "Standard Support", "Basic Analytics"],
  },
  {
    name: "Growth",
    desc: "For scaling businesses that need deeper operational control.",
    features: ["6 Products", "Up to 500 Users", "Priority Support", "Advanced Analytics", "API Access"],
    popular: true,
  },
  {
    name: "Enterprise",
    desc: "For large organizations with complex workflows and compliance.",
    features: ["All Products", "Unlimited Users", "Dedicated Support", "Custom Integrations", "SLA Guarantee"],
  },
];

export default function PricingSection() {
  const { open } = useDemoRequest();
  return (
    <section id="pricing" className="relative py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Flexible <span className="text-emerald-accent">Subscription-Based</span> Access
          </h2>
          <p className="text-silver-300 text-base md:text-lg max-w-2xl mx-auto">
            Modular, scalable, and built to grow with you. Pick what you need today, expand tomorrow.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`glass-card p-6 md:p-7 flex flex-col gap-5 ${
                plan.popular
                  ? "border-emerald-border shadow-[0_0_40px_-12px_rgba(16,185,129,0.2)]"
                  : ""
              }`}
            >
              {plan.popular && (
                <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-emerald-accent/10 border border-emerald-accent/30 self-start">
                  <span className="text-xs font-semibold text-emerald-soft">Most Popular</span>
                </div>
              )}
              <div>
                <h3 className="text-xl font-bold text-white mb-1">{plan.name}</h3>
                <p className="text-sm text-silver-400">{plan.desc}</p>
              </div>
              <ul className="space-y-2.5 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-center gap-2.5 text-sm text-silver-300">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-emerald-accent text-sm" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <button onClick={open} className="btn-primary text-center text-sm cursor-pointer">Request a Demo</button>
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 text-sm font-medium text-emerald-accent hover:text-emerald-hover transition-colors"
          >
            View detailed per-app pricing
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
